import StandardTypeahead from './StandardTypeahead';

const TypeaheadWithSubtext = ({
  options,
  placeholder = 'Select...',
  selectedOption,
  getSubtext,
  ...props
}) => {
  const customMenuItemChildren = (option) => (
    <small className="ml-1">{getSubtext(option)}</small>
  );
  return (
    <StandardTypeahead
      id="subtext-typeahead"
      align="left"
      customMenuItemChildren={customMenuItemChildren}
      labelKey="name"
      multiple
      options={options}
      paginate={false}
      placeholder={placeholder}
      selected={selectedOption}
      showCheckmark={false}
      {...props}
    />
  );
};

export default TypeaheadWithSubtext;
